var _linearGradient, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "placeholder 404",
    xmlns: "http://www.w3.org/2000/svg",
    width: 362,
    height: 175,
    viewBox: "0 0 362 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "y7fjxuzs8a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(502 267)",
    style: {
      fill: "red"
    },
    d: "M0 0h362v175H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s9remt1ivc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 205",
    style: {
      fill: "red"
    },
    d: "M0 0h39.685v39.685H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gzvbu38gvd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 10",
    d: "M15033-7365.764v-17.6h6v-4.26h-6V-7390h14v24.236z",
    transform: "translate(-14338 7781)",
    style: {
      fill: "#ff0009"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t9yj2trkqe"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 12",
    d: "M29437-15125.912a15.775 15.775 0 0 1-4.65-11.239 15.851 15.851 0 0 1 4.045-10.6l11.27 10.885 4.348 15.159a15.725 15.725 0 0 1-3.764.451 15.827 15.827 0 0 1-11.249-4.656zm11.729-9.931 10.521 10.168a15.983 15.983 0 0 1-6.529 3.785zm-.414-1.412-4.355-15.211a16.119 16.119 0 0 1 4.289-.584 15.932 15.932 0 0 1 3.777.451v-7.024h-5v-2.377h12v13.174q.231.215.457.439a15.794 15.794 0 0 1 4.66 11.24 15.845 15.845 0 0 1-4.379 10.959zm-1.059-1.028v.008zm-10.359-10c.023-.029.053-.052.074-.074l.029-.037a15.773 15.773 0 0 1 6.256-3.859l4 13.968z",
    transform: "translate(-28795.023 15544)",
    style: {
      fill: "red"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "yr2u7n79wf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 13",
    d: "M5.382 24.236H0v-2.38h5.38V16.34H9v7.9zM0 17.6V8.34h9v6H5.382v3.26z",
    transform: "rotate(180 7.001 12.119)",
    style: {
      fill: "#ff0009"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jsmehisllb",
    x1: 0.5,
    y1: 0.07,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe de masques 25",
    transform: "translate(-502 -267)",
    style: {
      clipPath: "url(#y7fjxuzs8a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "bg card",
    d: "M152 0h58a152 152 0 0 1 152 152H0A152 152 0 0 1 152 0z",
    transform: "translate(502 290)",
    style: {
      fill: "url(#jsmehisllb)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 198",
    d: "m-18.093-3.852 5.8-54.506h-21.15L-74.775-2.764l-1.329 13.9h39.883l-1.571 15.107h16.557l1.571-15.107h10.031l1.571-14.988zm-12.932-34.2-3.626 34.2H-56.4zm62 65.746c19.941 0 31.906-11.965 34.081-31.906L67.594-27.9c.121-1.692.242-3.384.242-4.834 0-17.041-10.514-27.072-28.522-27.072C19.372-59.808 7.408-47.843 5.232-27.9L2.815-4.214A34.86 34.86 0 0 0 2.573.741c0 16.92 10.394 26.951 28.402 26.951zm.967-16.074c-7.977 0-11.723-3.988-11.723-12.206 0-1.088 0-2.3.121-3.626L22.877-27.9c1.088-10.756 6.889-15.832 15.59-15.832 7.856 0 11.6 3.867 11.6 12.206 0 1.209 0 2.3-.121 3.626L47.411-4.214c-1.088 10.756-6.768 15.832-15.47 15.832zM133.219-3.852l5.8-54.506H117.87L76.537-2.764l-1.329 13.9h39.882l-1.571 15.107h16.557l1.571-15.107h10.031l1.572-14.988zm-12.932-34.2-3.626 34.2H94.908z",
    transform: "translate(649.427 326.808)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 199",
    d: "M15071.541-7284.908v-52.423c-3.189.061-6.871.091-10.956.091-4.524 0-9.623-.038-15.153-.114a12.352 12.352 0 0 1-8.792-3.637 12.349 12.349 0 0 1-3.641-8.788v-.372a12.372 12.372 0 0 1 3.641-8.8 12.373 12.373 0 0 1 8.8-3.641h26.1v-3.955c0-4.666 3.526-8.458 7.857-8.458s7.861 3.792 7.861 8.458v3.955h26.106a12.362 12.362 0 0 1 8.791 3.641 12.36 12.36 0 0 1 3.645 8.8v.372a12.442 12.442 0 0 1-12.436 12.425h-26.106v52.445zm5.6-84.4a4.174 4.174 0 0 0-1 2.771v79.622h6.521v-79.622c0-2.126-1.465-3.857-3.265-3.857a3 3 0 0 0-2.253 1.082zm10.116 27.681h26.106a8.162 8.162 0 0 0 8.157-8.146v-.372a8.158 8.158 0 0 0-8.157-8.143h-26.106zm-49.975-8.519v.372a8.158 8.158 0 0 0 8.153 8.146h26.1v-16.661h-26.1a8.155 8.155 0 0 0-8.15 8.139z",
    transform: "translate(-14396.401 7740.999)",
    style: {
      fill: "#a4b0b5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "urban + helmet"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe de masques 24",
    transform: "translate(633.232 402.315)",
    style: {
      clipPath: "url(#s9remt1ivc)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 9",
    d: "M19.106 38.952v-18.1l-9.051 15.673-.638-.369 9.052-15.677-15.677 9.052-.366-.637 15.68-9.052H0v-.735h18.1L2.426 10.055l.366-.637 15.676 9.05L9.417 2.792l.638-.366L19.106 18.1V0h.734v18.1l9.054-15.673.637.366-9.054 15.68 15.678-9.052.369.634-15.676 9.051h18.1v.735h-18.1l15.677 9.052-.369.637-15.677-9.052 9.051 15.678-.637.369-9.052-15.678v18.1z",
    transform: "rotate(-16 20.16 18.622)",
    style: {
      fill: "#d7d7d7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 20",
    d: "M653.223 405.956a15.9 15.9 0 0 0-11.241 27.136 15.9 15.9 0 1 0 22.481-22.481 15.792 15.792 0 0 0-11.24-4.656m0-3.675a19.571 19.571 0 1 1-19.571 19.572 19.571 19.571 0 0 1 19.571-19.571z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe de masques 26",
    transform: "translate(13 5.998)",
    style: {
      clipPath: "url(#gzvbu38gvd)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 185"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 206",
    d: "M5 2a3 3 0 0 0-3 3v12h6V5a3 3 0 0 0-3-3m0-2a5 5 0 0 1 5 5v14H0V5a5 5 0 0 1 5-5z",
    transform: "translate(697 391)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 200",
    d: "M2 0h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    transform: "translate(695 408)",
    style: {
      fill: "#151515"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe de masques 27",
    transform: "translate(0 15)",
    style: {
      clipPath: "url(#t9yj2trkqe)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 186"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 208",
    d: "M4.466 1.786a2.683 2.683 0 0 0-2.68 2.68v10.719h5.36V4.466a2.683 2.683 0 0 0-2.68-2.68m0-1.786a4.466 4.466 0 0 1 4.466 4.466v12.5H0v-12.5A4.466 4.466 0 0 1 4.466 0z",
    transform: "rotate(10.02 -1847.73 3921.786)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 201",
    d: "M1.786 0h8.932A1.786 1.786 0 0 1 12.5 1.786v2.68a1.786 1.786 0 0 1-1.786 1.786H1.786A1.786 1.786 0 0 1 0 4.466v-2.68A1.786 1.786 0 0 1 1.786 0z",
    transform: "rotate(10.02 -1933.447 3904.029)",
    style: {
      fill: "#c73232"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 218",
    width: 12,
    height: 2,
    rx: 1,
    transform: "translate(703 440)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 226",
    width: 5,
    height: 2,
    rx: 1,
    transform: "translate(759 440)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 227",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(769 440)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 228",
    width: 4,
    height: 2,
    rx: 1,
    transform: "translate(772 440)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 219",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(716 440)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 225",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(749 440)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 220",
    width: 4,
    height: 2,
    rx: 1,
    transform: "translate(684 440)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 221",
    width: 4,
    height: 2,
    rx: 1,
    transform: "translate(616 440)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 223",
    width: 4,
    height: 2,
    rx: 1,
    transform: "translate(586 440)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 224",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(607 440)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 222",
    width: 13,
    height: 2,
    rx: 1,
    transform: "translate(592 440)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe de masques 28",
    transform: "translate(690.995 376.048)",
    style: {
      clipPath: "url(#yr2u7n79wf)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 187"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 206",
    d: "M3.127 1.251A1.878 1.878 0 0 1 5 3.127v7.505H1.251V3.127a1.878 1.878 0 0 1 1.876-1.876m0-1.251A3.127 3.127 0 0 0 0 3.127v8.756h6.254V3.127A3.127 3.127 0 0 0 3.127 0z",
    transform: "translate(6.252 .888)",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 202",
    d: "M7.505 0H1.251C.56 0 0 .768 0 1.715v2.572C0 5.234.56 6 1.251 6h6.254c.695 0 1.251-.766 1.251-1.713V1.715C8.756.768 8.2 0 7.505 0z",
    transform: "translate(5.001 9.897)",
    style: {
      fill: "#e5701a"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder404);
export default __webpack_public_path__ + "static/media/placeholder404.409d207927f7a2ac02a97f5b4faf2d79.svg";
export { ForwardRef as ReactComponent };